export interface DocEntry {
  id: string;
  title: string;
  group: string;
  icon: string;
  sortOrder: number;
}

export const docsRegistry: DocEntry[] = [
  // Nhóm: Hệ thống
  {
    id: 'tong-quan',
    title: 'Tổng quan hệ thống',
    group: 'Hệ thống',
    icon: 'ri-book-open-line',
    sortOrder: 1,
  },
  {
    id: 'dashboard',
    title: 'Hướng dẫn Dashboard',
    group: 'Hệ thống',
    icon: 'ri-dashboard-3-line',
    sortOrder: 2,
  },
  {
    id: 'quan-tri',
    title: 'Quản trị Tài khoản & Phân quyền',
    group: 'Hệ thống',
    icon: 'ri-user-settings-line',
    sortOrder: 3,
  },

  // Nhóm: Nguồn lực
  {
    id: 'nhan-su',
    title: 'Quản lý Nhân sự & Đội nhóm',
    group: 'Nguồn lực',
    icon: 'ri-team-line',
    sortOrder: 10,
  },
  {
    id: 'kho-vat-tu',
    title: 'Quản lý Kho vật tư',
    group: 'Nguồn lực',
    icon: 'ri-store-3-line',
    sortOrder: 11,
  },
  {
    id: 'thiet-bi',
    title: 'Quản lý Thiết bị & Máy móc',
    group: 'Nguồn lực',
    icon: 'ri-tools-line',
    sortOrder: 12,
  },

  // Nhóm: Dự án & Thi công
  {
    id: 'du-an',
    title: 'Hồ sơ Dự án',
    group: 'Dự án & Thi công',
    icon: 'ri-building-2-line',
    sortOrder: 20,
  },
  // Nhóm: Dự toán & Định mức
  {
    id: 'estimates-norms',
    title: 'Thư viện Định mức',
    group: 'Dự toán & Định mức',
    icon: 'ri-book-read-line',
    sortOrder: 25,
  },
  {
    id: 'estimates-rates',
    title: 'Bảng giá Nguồn lực',
    group: 'Dự toán & Định mức',
    icon: 'ri-money-dollar-circle-line',
    sortOrder: 26,
  },
  {
    id: 'estimates-process-templates',
    title: 'Quy trình mẫu',
    group: 'Dự toán & Định mức',
    icon: 'ri-node-tree',
    sortOrder: 27,
  },
  {
    id: 'estimates-list',
    title: 'Quản lý danh sách Dự toán',
    group: 'Dự toán & Định mức',
    icon: 'ri-list-check-2',
    sortOrder: 28,
  },
  {
    id: 'estimates-lap-du-toan',
    title: 'Hướng dẫn lập Dự toán',
    group: 'Dự toán & Định mức',
    icon: 'ri-file-edit-line',
    sortOrder: 29,
  },
  {
    id: 'boq-thi-cong',
    title: 'BOQ Thi công',
    group: 'Dự án & Thi công',
    icon: 'ri-file-list-3-line',
    sortOrder: 22,
  },

  // Nhóm: Vận hành chung
  {
    id: 'cong-viec',
    title: 'Giao việc (Work Orders)',
    group: 'Vận hành chung',
    icon: 'ri-task-line',
    sortOrder: 30,
  },
  {
    id: 'de-xuat-phe-duyet',
    title: 'Đề xuất & Luồng duyệt',
    group: 'Vận hành chung',
    icon: 'ri-checkbox-circle-line',
    sortOrder: 31,
  },
  {
    id: 'bao-cao',
    title: 'Báo cáo & Thông báo',
    group: 'Vận hành chung',
    icon: 'ri-file-chart-line',
    sortOrder: 32,
  },

  // Nhóm: Bảo dưỡng
  {
    id: 'khu-vuc',
    title: 'Quản lý Khu vực & Cây xanh',
    group: 'Bảo dưỡng',
    icon: 'ri-map-pin-line',
    sortOrder: 40,
  },
  {
    id: 'phan-thuoc',
    title: 'Quản lý Nông hóa phẩm',
    group: 'Bảo dưỡng',
    icon: 'ri-flask-line',
    sortOrder: 41,
  },
  {
    id: 'dien-nuoc',
    title: 'Quản lý Điện - Nước',
    group: 'Bảo dưỡng',
    icon: 'ri-drop-line',
    sortOrder: 42,
  },
];

// Lấy danh sách nhóm theo thứ tự xuất hiện trong registry
export const docsGroups = Array.from(new Set(docsRegistry.sort((a, b) => a.sortOrder - b.sortOrder).map((doc) => doc.group)));
